import { render } from "./projectAssignLerder.vue?vue&type=template&id=eb18e3ba"
import script from "./projectAssignLerder.vue?vue&type=script&lang=js"
export * from "./projectAssignLerder.vue?vue&type=script&lang=js"

import "./projectAssignLerder.vue?vue&type=style&index=0&id=eb18e3ba&lang=css"

import exportComponent from "C:\\Project\\VuePro\\ERP\\erp-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__